import { render } from "./CoreScanner.vue?vue&type=template&id=97b25cf0&scoped=true"
import script from "./CoreScanner.vue?vue&type=script&lang=js"
export * from "./CoreScanner.vue?vue&type=script&lang=js"

import "./CoreScanner.vue?vue&type=style&index=0&id=97b25cf0&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97b25cf0"]])

export default __exports__